var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1000.000000pt",
    height: "1000.000000pt",
    viewBox: "0 0 1000.000000 1000.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1000.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1270 7365 l0 -1685 340 0 340 0 -2 1683 -3 1682 -337 3 -338 2 0 -1685z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4640 8375 l0 -675 340 0 340 0 0 675 0 675 -340 0 -340 0 0 -675z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8010 7025 l0 -2025 340 0 340 0 0 2025 0 2025 -340 0 -340 0 0 -2025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3767 6878 l-136 -153 -1 -339 0 -338 133 -184 132 -183 1082 -1 1083 0 135 169 135 168 0 334 0 334 -138 172 -137 173 -1076 0 -1076 0 -136 -152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 4834 l-133 -167 0 -339 0 -338 136 -170 136 -170 1074 0 1074 0 24 28 c14 15 77 92 140 172 l116 145 0 334 0 334 -135 168 -135 169 -1083 0 -1082 0 -132 -166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4640 2980 l0 -2020 340 0 340 0 0 2020 0 2020 -340 0 -340 0 0 -2020z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7137 4129 l-137 -172 0 -320 0 -320 135 -168 135 -169 1078 0 1077 1 132 167 133 167 0 323 0 322 -136 170 -136 170 -1072 0 -1072 0 -137 -171z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 1970 l0 -1010 340 0 340 0 0 1010 0 1010 -340 0 -340 0 0 -1010z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8017 2303 c-4 -3 -7 -307 -7 -675 l0 -668 340 0 340 0 -2 673 -3 672 -331 3 c-182 1 -333 -1 -337 -5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudio);
export default __webpack_public_path__ + "static/media/studio.013ee6f27f9528d06120393e1aeb725e.svg";
export { ForwardRef as ReactComponent };